import styled, { css } from 'styled-components'

const getFontWeight = (weight) => {
  switch (weight) {
    case 'black': return 900
    case 'bold': return 700
    case 'light': return 300
    case 'regular':
    default: return 400
  }
}

export const variantStyles = ({ variant, theme }) => {
  // fallback seguro a body1 si no existe
  const v = theme.typography?.[variant] ?? theme.typography?.body1 ?? {}

  return css`
    font-size: ${v.fontSize ?? '1rem'};
    line-height: ${v.lineHeight ?? '1.5'};
    font-weight: ${getFontWeight(v.fontWeight ?? 'regular')};
    color: ${theme.colors?.[v.color] ?? theme.colors?.textPrimary ?? '#000'};
    text-transform: ${v.textTransform ?? 'initial'};
    letter-spacing: ${v.letterSpacing ?? 'normal'};
  `
}

export const Root = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily};
  display: ${({ display }) => display || 'block'};
  font-style: ${({ italic }) => (italic ? 'italic' : 'normal')};
  margin: ${({ margin }) => margin || 0};
  padding: ${({ padding }) => padding || 0};
  width: ${({ width }) => width || 'auto'};
  white-space: ${({ noWrap }) => (noWrap ? 'nowrap' : 'normal')};
  ${({ variant, theme, lineHeight }) =>
    variantStyles({ variant, theme })}
  ${({ lineHeight }) =>
    lineHeight &&
    css`
      line-height: ${lineHeight};
    `}
`

export const Jumbo = styled(Root)`
  ${({ theme }) => variantStyles({ variant: 'jumbo', theme })}
`
